import {createContext} from 'react';

const SnackbarContext = createContext(null);

export default SnackbarContext;
